import { get } from 'lodash-es';

/**
 * Creates a function which which checks a file for certain extensions
 *
 * @param {[type]} ...exts One or more parameters representing extensions to check
 * @returns A function that checks a file for those extensions
 */
export const checkFileExt = (...exts) => (file) =>
  get(file, 'ext') && exts.indexOf(get(file, 'ext')) !== -1;

/**
 * Is Excel file?
 *
 * Call it as isExcelFile(file)
 *
 * @returns {boolean} Does file.ext equal 'xls' or 'xlsx'
 */
export const isExcelFile = checkFileExt('xls', 'xlsx');

/**
 * Is CSV file?
 *
 * Call it as isCsvFile(file)
 *
 * @returns {boolean} Does file.ext equal 'csv'?
 */
export const isCsvFile = checkFileExt('csv');

/**
 * Is PDF file?
 *
 * Call it as isPdfFile(file)
 *
 * @returns {boolean} Does file.ext equal 'pdf'?
 */
export const isPdfFile = checkFileExt('pdf');

/**
 * Is DOCX file?
 *
 * Call it as isDocxFile(file)
 *
 * @returns {boolean} Does file.ext equal 'docx'?
 */
export const isDocxFile = checkFileExt('docx');
